export interface SalesByPieceFiltersState {
  productCodeUnique: string;
  categoryName: string;
  saleDateFrom: string;
  saleDateTo: string;
  sellerSearch: string;
  locationId: string;
  hasCustomer: string;
  customerSearch: string;
  finalPriceMin: string;
  finalPriceMax: string;
  orderCode: string;
  branchReceiptCode: string;
  daysUntilSaleMin: string;
  daysUntilSaleMax: string;
}

export const emptySalesByPieceFilters = (): SalesByPieceFiltersState => ({
  productCodeUnique: '',
  categoryName: '',
  saleDateFrom: '',
  saleDateTo: '',
  sellerSearch: '',
  locationId: '',
  hasCustomer: '',
  customerSearch: '',
  finalPriceMin: '',
  finalPriceMax: '',
  orderCode: '',
  branchReceiptCode: '',
  daysUntilSaleMin: '',
  daysUntilSaleMax: '',
});
